import type { GetOrganizationsListQuery } from '../../../../graphql/query/organizations/GetOrganizationsList.generated';

export type AutocompleteOptions = {
  values: string[];
  labels: Record<string, string>;
};

type Organization = GetOrganizationsListQuery['account'][number];

export const mapOrganizationsToAutocompleteOptions = (
  organizations: Pick<Organization, 'id' | 'name'>[]
): AutocompleteOptions => {
  const values: string[] = [];
  const labels: Record<string, string> = {};

  for (let i = 0; i < organizations.length; i++) {
    values.push(organizations[i].id);
    labels[organizations[i].id] = organizations[i].name;
  }

  values.sort((a, b) => labels[a].localeCompare(labels[b]));

  return { values, labels };
};
